/*
 * SidebarUser
 * @module Sidebar
 * @flow weak
 */

import { compose, mapProps } from 'recompose';

import { withViewer } from '~/features/App/Viewer';

import { SidebarUser as SBU } from './SidebarUser';

const enhance = compose(
  withViewer,
  mapProps(({ viewer, ...rest }: ViewerQuery) => ({
    ...viewer,
    ...rest,
  })),
);

export const SidebarUser = enhance(SBU);
